import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { OrderComponent } from './order/order.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { RoundedStepComponent } from './rounded-step/rounded-step.component';
import { ProductsMenuComponent } from './products-menu/products-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { ProgressSpinnerComponent } from './progress-spinner/progress-spinner.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProgressSpinnerService } from './progress-spinner/progress-spinner.service';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';

@NgModule({
  declarations: [OrderComponent, RoundedStepComponent, ProductsMenuComponent, ProgressSpinnerComponent],
  exports: [OrderComponent, RoundedStepComponent, ProductsMenuComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    RouterModule,
    MatCardModule,
    MatIconModule,
    MatMenuModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    NgxGoogleAnalyticsModule,
  ],
  providers: [ProgressSpinnerService],
})
export class ComponentsModule {}
